import { render, staticRenderFns } from "./SetupLog.vue?vue&type=template&id=21794910&scoped=true&"
import script from "./SetupLog.vue?vue&type=script&lang=js&"
export * from "./SetupLog.vue?vue&type=script&lang=js&"
import style0 from "./SetupLog.vue?vue&type=style&index=0&id=21794910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21794910",
  null
  
)

export default component.exports